import ScrollMagic from 'scrollmagic/scrollmagic/minified/ScrollMagic.min';
import 'scrollmagic/scrollmagic/minified/plugins/animation.gsap.min';

// For development only
//import 'scrollmagic/scrollmagic/minified/plugins/debug.addIndicators.min';

const w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
    windowHeight = w.innerHeight || e.clientHeight || g.clientHeight,
    tagLine = document.getElementById("tagline"),
    trigger = document.getElementById("target");

if (trigger) {
    // init controller
    var controller = new ScrollMagic.Controller();

    var tween = TweenMax.to(tagLine, 0.5, {
        ease: Power1.easeInOut,
        x: -windowWidth,
        y: 0,
        z: 0,
        yoyo: true,
        force3D: "auto",
        perspective: 0
    });
    // build scene and set duration to window height
    var scene = new ScrollMagic.Scene({triggerElement: trigger, duration: windowHeight * 3, offset: -windowHeight / 2})
        .setTween(tween)
        //.addIndicators() // add indicators (requires plugin)
        .addTo(controller);
}




// WEBPACK FOOTER //
// ./resources/assets/js/animation.js